import React from "react";

import { Trans } from "react-i18next";
import { VehicleWhite } from '../../../Common/Buttons/Icons';

export const OrderStatusTopSection = ({ startExport, addVehicle }) => (
  <div className="titlebar">
    <div className="titlebar-left">
      <div className="left">
        <h1>
          <Trans>Order Status</Trans>
        </h1>
      </div>
    </div>
    <div className="titlebar-right">
      <div className="right">
        <div className="desktop-action">
          <a className="button primary px-32" onClick={() => addVehicle()}>
            <span className="mr-8" style={{ verticalAlign: "sub" }}>{VehicleWhite()}</span>
            <Trans>Add Vehicle</Trans>
          </a>
        </div>
      </div>
    </div>
  </div>
);
